import { render } from "./live-tracking.vue?vue&type=template&id=bafbf4b0"
import script from "./live-tracking.vue?vue&type=script&lang=js"
export * from "./live-tracking.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__